import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { financeService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'financeInstalledCapacity',
  initialState: adapter.getInitialState({
    busy: false,
    lastKey: null,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
    setQueryKey(state, action) {
      state.lastKey = action.payload || null;
    },
  },
});

const fetchList = (params) => async (dispatch, getState) => {
  const key = `${params?.company_id || 0}:${params?.company_affiliate_id || 0}:${params?.person_id || 0}`;
  const state = getState().financeInstalledCapacity;
  // If same request is already in-flight or already loaded, skip
  if ((state?.busy && state?.lastKey === key) || (state?.lastKey === key && (state?.ids || []).length > 0)) {
    return;
  }
  dispatch(slice.actions.setBusy(true));
  dispatch(slice.actions.setQueryKey(key));
  try {
    const resData = await financeService.fetchList(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchList,
};

const selectors = {
  ...adapter.getSelectors((state) => state.financeInstalledCapacity),
};

export { actions, selectors };

export default slice.reducer;
